window.addEventListener('SITE_START', () => {
  const searches = document.querySelectorAll('.search');
  if (!searches.length) return;

  searches.forEach(initSearch);

  function initSearch(searchEl) {
    const form = searchEl.querySelector('form');
    const input = searchEl.querySelector('.search__input');
    const button = searchEl.querySelector('.search__button');
    if (!input || !button || !form) return;

    toggleFilled();

    input.addEventListener('input', toggleFilled);

    // 버튼 클릭했을 때만 has-value 모드
    button.addEventListener('click', function (e) {
      const isFilled = searchEl.classList.contains('has-value');

      // 엔터로 눌린 click 은 e.detail === 0 이라서 통과시킴
      const isKeyboardClick = e.detail === 0;

      if (isFilled && !isKeyboardClick) {
        // 마우스로 클릭 시 clear
        e.preventDefault();
        clear();
      }
    });

    function clear() {
      input.value = '';
      toggleFilled();
      input.focus();
    }

    function toggleFilled() {
      const hasValue = input.value.trim().length > 0;
      searchEl.classList.toggle('has-value', hasValue);
    }
  }
});